import LxcError from "~/core/models/LxcError.class";
import type { SectorCreatePayload } from "~/modules/sector/models/SectorCreatePayload.interface";
import sectorsService from "~/modules/sector/services/sectors.service";

export function useCreateSector(organizationCode?: number) {
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function createSector(
    sectorCreatePayload: SectorCreatePayload,
  ): Promise<void> {
    isLoading.value = true;
    error.value = undefined;
    if (organizationCode) {
      const response = await sectorsService.createSector(
        organizationCode,
        sectorCreatePayload,
      );

      if (LxcError.check(response)) {
        error.value = response;
      }
    } else {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = false;
  }

  return {
    createSector,
    isLoading,
    error,
  };
}
